import { useElements } from "../element/elements";
import { i18n, joinList } from "@/i18n";
import type { ImpactMatrix } from "./ImpactMatrix";

export function getImpactMatrixTitle(impactMatrix: ImpactMatrix) {
  const elements = useElements();

  let title = "";

  if (impactMatrix.relationType == "impact") {
    title += i18n.t("objectNames.impact", 4);
  } else {
    title += i18n.t("objectNames.flow", 4);
  }
  title += ": ";

  if (impactMatrix.allIndices && impactMatrix.allTargets && impactMatrix.allResources) {
    title += i18n.t("labels.allElements");
  }
  else {
    const parts = [];
    if (impactMatrix.allTargets) {
      parts.push(i18n.t("labels.allTargets"));
    }
    if (impactMatrix.allResources) {
      parts.push(i18n.t("labels.allResources"));
    }
    if (impactMatrix.allIndices) {
      parts.push(i18n.t("labels.allIndices"));
    }

    for (const uid of impactMatrix.elementUids) {
      const element = elements.byUid[uid];
      if (!element) continue;

      if (!impactMatrix.allTargets && uid.startsWith("target_")) {
        parts.push(element.title);
      }
      if (!impactMatrix.allResources && uid.startsWith("resource_")) {
        parts.push(element.title);
      }
      if (!impactMatrix.allIndices && uid.startsWith("index_")) {
        parts.push(element.title);
      }
    }

    title += (joinList(parts, "and") || i18n.t("labels.emptyImpactMatrix")); // TODO: Check translations
  }
  
  return title;
}